import React from 'react';
import Delete from './Delete';
import UpdateProduct from './UpdateProduct';
import UpdateProductShop from './UpdateProductShop';

import { Fade, Card, Stack, Checkbox, CardHeader, CardActionArea, CardContent, Typography } from '@mui/material';

import { CustomList } from 'components';
import { addCommas } from '@persian-tools/persian-tools';

export default function Model({ model, delay, checked, refetch, isAssign, handleSelect }) {
  const { id, title, barcode, shop, me_price, action_type } = model;

  return (
    <>
      <Fade in timeout={{ appear: delay * 150, enter: delay * 170, exit: delay * 190 }}>
        <Stack direction="row" alignItems="center">
          {isAssign && <Checkbox size="small" checked={checked} onChange={handleSelect} />}
          <Card
            sx={{
              width: '100%',
              position: 'relative',
              bgcolor: checked && 'action.disabledBackground',
            }}
            variant="outlined"
          >
            <CardHeader
              sx={{ p: 1 }}
              title={<Typography variant="subtitle2" fontSize={14}>{title}</Typography>}
              action={
                <Stack direction="row" columnGap={0.5}>
                  {action_type === 'CREATE_PRODUCT' || action_type === 'SYNC' ? (
                    <UpdateProduct id={id} refetch={refetch} />
                  ) : (
                    <UpdateProductShop id={id} refetch={refetch} />
                  )}
                  <Delete id={id} refetch={refetch} />
                </Stack>
              }
            />
            <CardContent>
              <CustomList
                data={{
                  title: 'فروشگاه',
                  value: shop?.title,
                  children: [
                    {
                      title: 'بارکد',
                      value: barcode,
                    },
                    {
                      title: 'قیمت فروشگاه',
                      value: addCommas(Number(me_price)),
                      unit: 'تومان',
                    },
                  ],
                }}
              />
            </CardContent>
            <CardActionArea
              sx={{
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                zIndex: 1,
                position: 'absolute',
              }}
              disabled={!isAssign}
              onClick={handleSelect}
            />
          </Card>
        </Stack>
      </Fade>
    </>
  );
}
